import { GetCampaignsResponse } from '@flexible-reports/store/api/campaigns/api-types';
import { GetCampaignsResponseForReact } from '@flexible-reports/store/api/campaigns/types';
import { isUnifiedReportingEnabled } from '@flexible-reports/utils/app-utils';

export const transformFromQueryCampaigns = (response: GetCampaignsResponse): GetCampaignsResponseForReact => {
  const isUnification = isUnifiedReportingEnabled();
  return {
    totalResults: response.totalResults,
    nextPaginationToken: response.nextPaginationToken,
    campaigns: (response.campaigns || []).map(campaign => ({
      campaignId: (isUnification ? campaign.campaignId : campaign.campaignCfid) || '',
      campaignName: campaign.campaignName || '',
      advertiserId: (isUnification ? campaign.accountId : campaign.advertiserCfid) || '',
      managerAccountIds: campaign.managerAccountIds || []
    }))
  };
};
